import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { BarChart3, FileUp } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/cro",        label: "Insights", icon: BarChart3, testid: "cro-subnav-insights" },
  { to: "/cro/inputs", label: "Inputs",   icon: FileUp,    testid: "cro-subnav-inputs"   },
];

export default function CroSubNav() {
  const location = useLocation();
  return (
    <div className="mb-6 border-b border-border" data-testid="cro-subnav">
      <nav className="flex items-center gap-1">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = t.to === "/cro" ? location.pathname === "/cro" : location.pathname.startsWith(t.to);
          return (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={t.testid}
              className={cn(
                "inline-flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px",
                active
                  ? "text-primary border-primary"
                  : "text-muted-foreground border-transparent hover:text-primary hover:border-accent/40"
              )}
            >
              <Icon size={14} />
              {t.label}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
